import script from "./confirm-unreview-template-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./confirm-unreview-template-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__